// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, Theme, Typography } from "@outschool/backpack";
import {
  LightListingCard_ListingFragment,
  ListingCard_ListingFragment,
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { StarRatings } from "@outschool/ui-components-website";
import React from "react";

export default function Stars({
  activity,
  leader,
  isMobile = false,
  starColor,
  expandReviewsText = false,
  isSimplified = false,
}: {
  activity:
    | ListingCard_ListingFragment["activity"]
    | LightListingCard_ListingFragment["activity"];
  leader:
    | ListingCard_ListingFragment["leader"]
    | LightListingCard_ListingFragment["leader"];
  isMobile?: boolean;
  starColor?: string;
  expandReviewsText?: boolean;
  isSimplified?: boolean;
}) {
  const { t } = useTranslation(
    "client\\components\\listings\\components\\Stars",
  );
  const rating = activity.isClub
    ? (
        leader as ListingCard_ListingFragment["leader"]
      ).averageActivityStarRating
        ?.toString()
        ?.substr(0, 4)
    : activity.averageStarRating?.toString()?.substr(0, 4);

  const reviewCount = (activity as ListingCard_ListingFragment["activity"])
    .isClub
    ? (leader as ListingCard_ListingFragment["leader"]).reviewCount
    : activity.reviewCount;
  const fontSize = isMobile ? 14 : 16;

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <StarRatings
        rating={1}
        starCount={1}
        color={starColor}
        sx={(theme: Theme) => ({
          fontSize: `${theme.typography.pxToRem(fontSize)}`,
          marginRight: "4px",
        })}
      />{" "}
      {rating && !!reviewCount && (
        <Typography
          as={Box}
          variant="inherit"
          sx={(theme: Theme) => ({
            color: "grey.900",
            fontWeight: !isSimplified ? "fontWeightBold" : "",
            marginRight: "4px",
            fontSize: `${theme.typography.pxToRem(fontSize)}`,
          })}
        >
          {`${rating}${rating.length === 1 ? ".0" : ""}`}
        </Typography>
      )}
      <Typography
        as={Box}
        variant="inherit"
        sx={(theme: Theme) => ({
          color: "#6A7482",
          fontWeight: !isSimplified ? "fontWeightBold" : "",
          margin: "0 4px",
          fontSize: `${theme.typography.pxToRem(fontSize)}`,
          fontVariantLigatures: "none",
        })}
      >
        (
        {expandReviewsText
          ? t("{{numReviews}} review", {
              numReviews: activity.reviewCount,
              count: activity.reviewCount,
              defaultValue_plural: "{{numReviews}} reviews",
            })
          : reviewCount?.toLocaleString()}
        )
      </Typography>
    </Box>
  );
}
